import { downloadMethods, downloadWarnings } from '@/mocks/content';

export default function DownloadSection() {
  return (
    <section id="download" className="w-full scroll-mt-20 bg-orange-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-sm font-medium text-orange-400">迅雷下载</span>
          <h2 className="font-heading mt-2 text-2xl md:text-4xl font-bold text-white">
            下载看：先读懂资源信息，再决定要不要下
          </h2>
          <p className="mt-4 text-stone-300 leading-relaxed">
            用迅雷等下载工具时，真正决定成败的往往不是工具，而是你是否看懂了资源本身。
            下面把常见的几种资源形式拆开讲清楚，最后附上几条安全提醒。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-5">
          {downloadMethods.map((m) => (
            <article
              key={m.name}
              className="bg-white rounded-xl p-6 border border-stone-800/10"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-orange-100 text-orange-600">
                    <i className={`${m.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="font-heading text-lg font-semibold text-stone-900">{m.name}</h3>
                </div>
                <span className="shrink-0 px-2.5 py-1 rounded-full bg-amber-100 text-amber-700 text-xs">
                  {m.label}
                </span>
              </div>
              <p className="mt-4 text-sm text-stone-600 leading-relaxed">{m.desc}</p>
              <ul className="mt-4 space-y-2">
                {m.points.map((p) => (
                  <li key={p} className="flex items-start gap-2 text-sm text-stone-700">
                    <i className="ri-check-line text-orange-500 mt-0.5" aria-hidden="true"></i>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="mt-8 bg-white/5 border border-white/10 rounded-xl p-6">
          <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-white">
            <i className="ri-shield-keyhole-line text-orange-400" aria-hidden="true"></i>
            下载安全提醒
          </h3>
          <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
            {downloadWarnings.map((w) => (
              <li key={w} className="flex items-start gap-2 text-sm text-stone-300">
                <i className="ri-arrow-right-s-line text-orange-400 mt-0.5" aria-hidden="true"></i>
                <span>{w}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}